import React from 'react';
import ReactDOM from 'react-dom';
import 'reflect-metadata';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import moment from 'moment';
import { I18_READY } from 'i18n';
import { ROOT_RENDER_ID } from 'project-constants';

import { store, runInitServices } from './store';
import { RootScene } from './scenes';
import { omjsModification } from './utils/omjs-modifacation';
import 'rc-select/assets/index.less';
import 'styles';

export default async (
    host: string, p_id: string, mapCode: string, mapName: string
) => {
    const startPromise = new Promise((resolve, reject) => {
        // Do something before rendering app
        resolve(true);
    });

    await Promise.all([
        startPromise,
        I18_READY
    ]);

    if (__IS_CORDOVA__ && omjs === undefined) {
        ReactDOM.render(
            <div className="no-internet">
                <div className="no-internet__message">
                    {i18n.t('no-internet')}
                </div>
                <div
                    className="no-internet__button"
                    onClick={() => window.location.reload()}
                >
                    {i18n.t('Повтор')}
                </div>
            </div>,
            document.getElementById(ROOT_RENDER_ID)
        );
        return;
    }


    omjsModification();

    if (process.env.NODE_ENV === 'development') {
        i18n.on('missingKey', (lngs, namespace, key, res) => {
            /* eslint-disable-next-line no-console */
            console.warn(`Translation warn: key is missing: -> ${key}`);
        });
    }

    moment.locale(i18n.language);

    runInitServices();

    ReactDOM.render(
        <Provider store={store}>
            <Router>
                <I18nextProvider i18n={i18n}>
                    <RootScene
                        projectId={p_id}
                        mapCode={mapCode}
                        mapName={mapName}
                        apiHost={host}
                    />
                </I18nextProvider>
            </Router>
        </Provider>,
        document.getElementById(ROOT_RENDER_ID)
    );
};
